module.exports = __webpack_public_path__ + "img/co-investing-4.e178d51b.jpg";